module.exports = __webpack_public_path__ + "2f1c7f472b98f665954335d751e40967.png";